import "whatwg-fetch";

import { initializeAppConfig } from "@relode/core/modules/appConfig";
import { initializeRelodeConstants } from "@relode/core/modules/constants";

import * as React from "react";
import * as ReactDOM from "react-dom";

import { Root } from "./root";

// NOT 100% foolproof but this prevents us from trying to render anything when we
// know the browser isn't supported.  Evaluation of react Javascript still happens
// and could still generate errors.
if ((window as any).browserSupported) {
    initializeAppConfig();
    initializeRelodeConstants();

    ReactDOM.render(<Root />, document.getElementById("root"));
} else {
    // let index.html handle the modal
    window.console &&
        console.warn(
            "relode | browser check | unsupported browser detected -- halting application rendering"
        );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();
